export const Logo = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      fill="#D4AF37"
      d="M32 4 52 14v18c0 14-9 24-20 28C21 56 12 46 12 32V14L32 4z"
    />
    <path
      fill="#080808"
      d="M32 12 45 19v13c0 10-6.5 17.5-13 20.5C25.5 49.5 19 42 19 32V19l13-7z"
    />
    <path
      fill="#D4AF37"
      d="M32 16 41 21v11c0 7.5-4.7 13-9 15.5-4.3-2.5-9-8-9-15.5V21l9-5zm-2 8h4v12h-4z"
    />
  </svg>
);
